import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { connect } from "react-redux";
import style from "./Room.module.css";
import { fetchRoomList } from "../../redux";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import api from "../../utils/Api";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";

export class Room extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      isEditMode: "",
      isDataFetched: false,
      room_id: "",
      roomList: [],
      errorResponse: "",
      isErrorModalOpen: false,
      isDeleteLoading: false,
    };
    this.setLoader = this.setLoader.bind(this);
  }
  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="Edit Room" to={{ pathname: `/app/roomcreation/${row.room_id}` }}>
          <i class="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>
        <Link title="Delete Room"
          class="action-icons relatedpartylist-add-icon"
          onClick={() => this.toggle(row)}
        >
          <i class="fa fa-trash"></i>
        </Link>
      </div>
    );
  }

  componentDidMount = async() => {
    document.title = 'Rooms - TechToMedix';
   await this.props.fetchRoomList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.roomListData && 
      this.props.roomListData.roomList && 
      this.props.roomListData.roomList.room){
      this.setState({
        roomList: this.props.roomListData.roomList.room
      })
    }
    setTimeout(() => {
      if (this.props.roomListData.roomList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callRoomLisAPI = async() => {
    this.setState({
      roomList: []
    })
    await this.props.fetchRoomList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page
    );
    if(this.props.roomListData && 
      this.props.roomListData.roomList && 
      this.props.roomListData.roomList.room){
      this.setState({
        roomList: this.props.roomListData.roomList.room
      })
    }
    setTimeout(() => {
      if (!this.props.roomListData.loading) {
        this.setState({
          isDataFetched: true,
        });
      }
    }, 1000);

  }

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
     this.callRoomLisAPI();
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false
     },()=>{
      this.callRoomLisAPI();
     });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: false 
    },()=>{
      this.callRoomLisAPI();
     });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  toggle = (val) => {
    this.setState((prevState) => ({
      room_id: val.room_id,
      isModalOpen: !prevState.isModalOpen,
    }));
  };

  errorToggle = () => {
    this.setState((prevState) => ({
      isErrorModalOpen: !prevState.isErrorModalOpen,
    }));
  };

  // Delete API calling
  onDeleteRoom = async () => {
    this.setState({
      isDeleteLoading: true,
    });
    try {
      const response = await api.delete("room", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data: {
          room_id: this.state.room_id,
        },
      });
      //console.log("********** Room delete response **********", response);
      if (response.status === 200) {
        this.setState({
          isDeleteLoading: false,
          successMessage: "Room deleted successfully!",
        });
        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isModalOpen: !prevState.isModalOpen,
          }));
            this.callRoomLisAPI();
        }, 3000);
      }
    } catch (error) {
     // console.log("********** error **********", error.response.data);
      this.setState(
        {
          errorMessage: error.response.data.message,
          isDeleteLoading: false,
        },
        () => {
          if (this.state.errorMessage) {
            setTimeout(() => {
            this.setState((prevState) => ({
              isModalOpen: !prevState.isModalOpen,
              //isErrorModalOpen: !prevState.isErrorModalOpen,
            }));
          }, 3000);
          }
        }
      );
    }
  };

  render() {
    const roomList = this.props.roomListData.roomList;

    return (
      <div className={style.roomListMainWarapper}>
        <div className="row">
          <div className="col-md-4 order-1">
            <h3>Room List</h3>
          </div>
<div class="col-xl-8 order-3 order-md-2 d-flex flex-wrap  justify-content-start justify-content-md-end RelatedPartiesList_addRoleBtnWrapper__3C9uO">
                <div className="form-group mr-3">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
                
               { checkIfPermitted(Permissions.CONFIGURE_ROOM) && ( 
               <Link to="/app/roomcreation">
                      <Button color="primary" className={style.addBtn}>
                        <i className="fa fa-plus mr-2"></i>ADD ROOM
                      </Button>
                </Link>  )}       
                   </div>



        </div>
        <div className="row">
          <div class="col-md-12 order-2 order-md-3 intro-text">
              <p class="mb-3">
              All the rooms that are available to the practice for Appointments are listed here. 
              Rooms must be associated to Professionals/Doctors when they are created.
              </p>
            </div>
        </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.roomList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.roomListData.roomList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn dataField="room_name" isKey dataSort={true}>
            Room Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="location_name" dataSort={true}>
            Location
          </TableHeaderColumn>
          <TableHeaderColumn dataField="contact_person" dataSort={true}>
            Contact Person
          </TableHeaderColumn>
          <TableHeaderColumn dataField="contact_number" dataSort={true}>
            Phone Number
          </TableHeaderColumn>

          {checkIfPermitted(Permissions.CONFIGURE_ROOM) && (<TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            width="20%"
          >
            Actions
          </TableHeaderColumn>)}
        </BootstrapTable>
        {/* Open a modal for delete Room */}
        <Modal
          isOpen={this.state.isModalOpen}
          toggle={this.toggle}
          className={style.deleteReason}
          centered
        >
          <ModalHeader toggle={this.toggle} className={style.deleteModalHeader}>
            Delete Room
          </ModalHeader>
          <ModalBody>
            <div className={style.deleteReasonHeadingWrapper}>
              <p>
                Please confirm whether you want to delete a room.
              </p>
            </div>

            <div className={style.deleteReasonFormWrapper}>
              <form>
                <div className={style.error}>{this.state.errorField}</div>

                <div className="row">
                  <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                    <button
                      type="button"
                      className="ttm-primary-btn"
                      onClick={this.onDeleteRoom}
                    >
                      Delete
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        {/* Open a modal for delete error */}
        <Modal
          isOpen={this.state.isErrorModalOpen}
          toggle={this.errorToggle}
          className="deleteRoomErrorModal"
          centered
        >
          <ModalHeader
            toggle={this.errorToggle}
            className={style.deleteRoomHeader}
          ></ModalHeader>
          <ModalBody>
            <div className={style.roomDeleteInfoWrapper}>
              <p>Room can not be deleted as it is occupied</p>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    roomListData: state.roomList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchRoomList: (searchKey, sortBy, page) =>
      dispatch(fetchRoomList(searchKey, sortBy, page)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Room);
